"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsUsersClient
 * @description  Notifications Subscriptions Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsUsersClient` uses `notificationsSubscriptionsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var NotificationsSubscriptionsUsersClient = /** @class */ (function () {
    function NotificationsSubscriptionsUsersClient(notificationsSubscriptionsUsersRoute, NotificationsSubscriptionsUsersBatchClient, apiClient) {
        this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        this.NotificationsSubscriptionsUsersBatchClient = NotificationsSubscriptionsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "batch", {
        get: function () {
            return this.NotificationsSubscriptionsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user subscription action has been performed; this action creates a new user subscription resource.
     * @method
     * @param data An UserSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user subscription action has been performed.
     * @example notificationsSubscriptionsUsersClient.create({
                    channel: '<channel-name>',
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsUsersClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    userIds: '<user-id1>,<user-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsUsersClient.get('<subscription-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user subscription action has been performed. This action will remove a user subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @returns A promise that is resolved once the remove user subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    notificationsSubscriptionsUsersClient.remove(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user subscription action has been performed; this action updates a user subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example // subscription is a resource previously fetched using get action.
                       subscription.channel = '<channel-name>';
                       notificationsSubscriptionsUsersClient.update(subscription)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    */
    NotificationsSubscriptionsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchClient !== "undefined" && _1.NotificationsSubscriptionsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsUsersClient);
    return NotificationsSubscriptionsUsersClient;
}());
exports.NotificationsSubscriptionsUsersClient = NotificationsSubscriptionsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
